module.exports = __webpack_public_path__ + "img/loupe_small.036630f8.svg";